import DealerList from './DealerList';

export default DealerList;
